import './App.css';
import Survey from './survey_page/Survey'
import React, {useState, useEffect} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import { firestore } from "./firebase";
import { findByPlaceholderText } from '@testing-library/react';

function App() {
  const [base, setBase] = useState(1);
  const [loading, setLoading] = useState(true);
  const [fireBaseDocId, setFireBaseDocId] = useState(null);
  const questionLen = 10;
  
  async function getData(){
    setLoading(true);
    try {
      const bucket = firestore.collection("1");
        bucket.add({}).then((docRef)=>{
          setFireBaseDocId(docRef.id);
          setLoading(false);
        })
      }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    getData();
  }, []);


  const onButtonClick = () =>{
    /*save logic*/
    let checkboxes = 0;
    for(let i=0; i<questionLen; i++){
      let index = base +i;
      let checkBox = document.getElementsByName('checkBox'+index)
      for(let j=0; j<checkBox.length; j++)
        if(checkBox[j].checked)
          checkboxes++;
    }
    if(checkboxes!==questionLen){
      alert("모든 문항에 답해주세요");
      return;
    }
    else{
      for(let i=0; i<10; i++){
        const checkboxes = document.getElementsByName('checkBox' + (base+i));
        for (let j = 0; j < checkboxes.length; j++) {
          checkboxes[j].checked = false
        }
      }
      setBase(base+10);
    }
  }
  if(loading || fireBaseDocId===null)
    return (
      <h4>Loading...</h4>
    )
  return (
    <div className='App'>
      <Survey number={base} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+1} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+2} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+3} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+4} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+5} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+6} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+7} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+8} fireBaseDocId ={fireBaseDocId}/>
      <Survey number={base+9} fireBaseDocId ={fireBaseDocId}/>
      <Button onClick={onButtonClick}>Next</Button>
    </div>
  );
}



export default App;
